import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Tooltip } from 'react-bootstrap';
import styled from '@emotion/styled';
const uuid = require('uuid');

const KeyboardUtil = require('../../util/keyboard');

let TriggerSpan = styled.span`
    display: inline-block;
    overflow: hidden;
`;

const propTypes = {
    id: PropTypes.string.isRequired,
    //children: PropTypes.node,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    tooltipTitle: PropTypes.string,
    className: PropTypes.string,
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    delay: PropTypes.number,
    icon: PropTypes.string, // fontawesome icon classname
    triggerElem: PropTypes.oneOfType([PropTypes.element,PropTypes.string]), // optional. replace font awesome icon with custom element
    disabled: PropTypes.bool,
    title: PropTypes.string,
    triggerWrapperClassName: PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
    // 'aria-description': PropTypes.string, // accessible text-only description which can be provided as alternative to props.children
    // 'aria-description' was removed because the library used by Overlay component auto-sets aria-describedby, giving the trigger _two_ descriptions
};

const defaultProps = {
    //children: null,
    placement: 'top',
    tooltipTitle: '',
    className: '',
    icon: 'fa-question-circle-o',
    triggerElem: null,
    disabled: false,
    title: '',
    triggerWrapperClassName: '',
    'aria-label': '',
    'aria-labelledby': '',
    // 'aria-description': '',

};


const AccessibleTooltip = (props) => {
    const [show, setShow] = useState(false);
    const targetRef = useRef(null);

    const handleMouseEnter = () => {
        if (!props.disabled) {
            setShow(true);
        }
    }
    const handleMouseLeave = (e) => {
        if (!targetRef.current.contains(e.relatedTarget)) {
           setShow(false);
        }
    };
    
    const handleKeyDown = (e) => {
        e.stopPropagation();
        if (KeyboardUtil.isEscKey(e.keyCode)) {
            setShow(false);
        }
        else if (KeyboardUtil.isSelectKey(e.keyCode)) {
            if (!props.disabled) {
                e.preventDefault(); // prevent scrolling in case of space key
                setShow(true);
            }
        }
    }

    const {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        // "aria-description": ariaDescription,
        triggerElem,
        className,
        ...myProps
    } = props; // separate trigger props from overlay props
    const overlayId = `${props.id}-overlay`;
    const focusOrMouseEvents = {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
    };
    const triggerProps = {
        id: props.id,
        ref: targetRef,
        tabIndex: "0",
        role: "button",
        'aria-controls': overlayId,
        onKeyDown: handleKeyDown,
        ...focusOrMouseEvents
    };

    if (ariaLabelledBy) {
        triggerProps['aria-labelledby'] = ariaLabelledBy;
    }
    else if (ariaLabel) {
        triggerProps['aria-label'] = ariaLabel;
    }

    // console.log('ariaDescription', ariaDescription);
    let accessibleDescriptionId;
    let descElement = null;
    /*if (!!ariaDescription) {
        if (props.id) {
            accessibleDescriptionId = props.id + '-aria-desc';
        }
        else {
            accessibleDescriptionId = uuid.v4();
        }

        descElement = (
            <span className="sr-only" id={accessibleDescriptionId}>
                {ariaDescription}
            </span>
        );

        if (show) {
            triggerProps['aria-describedby'] = accessibleDescriptionId;
        }
    }
    else {
        triggerProps['aria-describedby'] = overlayId;
    }*/

    let optionalOverlayProps = {};
    if (props.tooltipTitle) {
        optionalOverlayProps.title =  props.tooltipTitle;
    }

    return (
        <>
            {descElement}
            {(!!props.triggerElem) ?
                <span
                    className={className}
                    {...triggerProps}
                >
                    {triggerElem}
                </span>
                :
                <TriggerSpan
                    className={`fa ${props.icon} ${className}`}
                    {...triggerProps}
                />
            }
            <Overlay target={targetRef.current} show={show} placement={props.placement}>
                 {({ placement, arrowProps, show: _show, popper, ...props }) => (
                    <div
                        {...props}
                        id={overlayId}
                        role="tooltip"
                        className="popover accessible-tooltip"
                        {...focusOrMouseEvents}
                        {...optionalOverlayProps}
                    >
                        {myProps.children}
                    </div>
                )}
            </Overlay>
        </>
    );
};

AccessibleTooltip.propTypes = propTypes;
AccessibleTooltip.defaultProps = defaultProps;

export default AccessibleTooltip